var $ = require('js/sw-jquery/sw-jquery');

/*
   TODO - This needs to be changed to a Vue component, until then do not include this as a view  builder in shapeways.js.
 */
module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-gallery]').each(function () {

    var $el = $(this);
    var $nextArrow = $el.swFindWithSelf('[data-sw-gallery-next-arrow]');
    var $prevArrow = $el.swFindWithSelf('[data-sw-gallery-previous-arrow]');
    var $galleryClose = $el.swFindWithSelf('[data-sw-gallery-close]');
    var $galleryOpen = $el.swFindWithSelf('[data-sw-gallery-open]');
    var $galleryImage = $el.swFindWithSelf('[data-sw-gallery-image]')
    var $mainWindow = $el.swFindWithSelf('[data-sw-gallery-main-window]');
    var $thumbnailSection = $el.swFindWithSelf('[data-sw-gallery-thumbnail-section]');
    var $thumbnailImageContainer = $el.swFindWithSelf('[data-sw-gallery-thumbnail-container]');

    var galleryClosed = function(event){
      $mainWindow.addClass('sw--is-hidden');
    };

    var galleryOpened = function (event) {
      $mainWindow.removeClass('sw--is-hidden');
    };

    var selectPreviousImage = function (event) {
      deselectImageAndTransform('prev', event);
    };

    var selectNextImage = function (event) {
      deselectImageAndTransform('next', event);
    };

    var imageSelected = function(event){
      deselectImageAndTransform('', event);
    }

    /*
      Determines the image selected
     */
    var findSelectedImage = function($currentlySelectedImage, direction, event){
      var selectedImage = '';
      if (direction === 'next') {
        selectedImage = $currentlySelectedImage.next().find('img');
      } else if (direction === 'prev') {
        selectedImage = $currentlySelectedImage.prev().find('img');
      } else {
        selectedImage = $(event.target);
      }
      return selectedImage;
    };

    /*
      Determines the direction to translate
     */
    var shiftDirection = function(centerOffset, event){
      var directionToShift = 'right';
      if (event.pageX > centerOffset) {
        directionToShift = 'left';
      }
      return directionToShift;
    };

    /*
      Checks if image clicked is part of the left edge
     */
    var isLeftEdgeSection = function(selectedImage) {
      var center = $thumbnailSection.width() / 2;
      var imagePositionInContainer = selectedImage.length > 0 ? selectedImage.parent().position().left + 20 : 0;
      var isEdgeSection = false;
      if (imagePositionInContainer < center) {
        isEdgeSection = true;
      }
      return isEdgeSection;
    };

    /*
      Checks if image clicked is part of right edge
     */
    var isRightEdgeSection = function (selectedImage) {
      var center = $thumbnailSection.width() / 2;
      var imagePositionInContainer = selectedImage.length > 0 ? selectedImage.parent().position().left + 20 : 0;
      var isEdgeSection = false;
      var rightImagePositionInContainer = ($thumbnailImageContainer.width() - imagePositionInContainer) - 40;
      if (rightImagePositionInContainer < center) {
        isEdgeSection = true;
      }
      return isEdgeSection;
    };

    /*
      Checks if any of the thumbnailContainer's borders are aligned with the thumbnailSection's
     */
    var isLeftBorderAligned = function(thumbnailContainerLeftBorderOffset, thumbnailSectionLeftBorderOffset){
      //Are one of the thumbnailContainer's borders aligned with the thumbnailSection's border ?
      var isBorderAligned = false;
      if (thumbnailContainerLeftBorderOffset === thumbnailSectionLeftBorderOffset) {
        isBorderAligned = true;
      }
      return isBorderAligned;
    };

    var isRightBorderAligned = function(thumbnailContainerRightBorderOffset, thumbnailSectionRightBorderOffset){
      var isBorderAligned = false;
      if (thumbnailContainerRightBorderOffset === thumbnailSectionRightBorderOffset) {
        isBorderAligned = true;
      }
      return isBorderAligned;
    };

    /*
      Applies the transformation
     */
    var applyTransform = function(distanceFromCenter, isRightEdgeSection, isLeftEdgeSection, isRightBorderAligned, isLeftBorderAligned, directionToShift, thumbnailSectionRightBorderOffset, thumbnailContainerRightBorderOffset){
      var currTrans = $thumbnailImageContainer.css('transform').split(/[()]/)[1];
      var posx = currTrans ? window.Math.abs(currTrans.split(',')[4]) : 0;
      var transVal = posx + distanceFromCenter;

      if (isRightEdgeSection || isLeftEdgeSection) {
          if (isLeftEdgeSection && !isLeftBorderAligned && directionToShift === 'right') {
            $thumbnailImageContainer.css({'transform': 'translateX(0px)'});
          }
          else if (isRightEdgeSection && !isRightBorderAligned && directionToShift === 'left') {
            transVal = posx + (thumbnailSectionRightBorderOffset - thumbnailContainerRightBorderOffset);
            $thumbnailImageContainer.css({'transform': 'translateX(-' + transVal + 'px)'});
          }
      } else {
        $thumbnailImageContainer.css({'transform': 'translateX(-' + transVal + 'px)'});
      }
    };

    /*
      Logic for deselecting currently selected image, selecting new image, and translating thumbnail container
     */
    var deselectImageAndTransform = function(direction, event){
      var $currentlySelectedImage = $el.swFindWithSelf('.sw-gallery__center-content-thumbnail--selected');
      var selectedImage = findSelectedImage($currentlySelectedImage, direction, event);

      //Center Offsets
      var centerOffset = $thumbnailSection.offset().left + $thumbnailSection.width() / 2;
      var imageLeftOffset = selectedImage.length > 0 ? selectedImage.parent().offset().left : 0;
      var imageCenterOffset = imageLeftOffset + selectedImage.parent().width() / 2;
      var distanceFromCenter = imageCenterOffset - centerOffset;

      var thumbnailContainerLeftBorderOffset = $thumbnailImageContainer.offset().left;
      var lastChild = $thumbnailImageContainer.last();
      var thumbnailContainerRightBorderOffset = window.Math.round(window.outerWidth - (lastChild.offset().left + lastChild.outerWidth()));
      var thumbnailSectionRightBorderOffset = window.outerWidth - ($thumbnailSection.offset().left + $thumbnailSection.outerWidth());
      var thumbnailSectionLeftBorderOffset = $thumbnailSection.offset().left;

      var rightBorderAligned = isRightBorderAligned(thumbnailContainerRightBorderOffset, thumbnailSectionRightBorderOffset);
      var leftBorderAligned = isLeftBorderAligned(thumbnailContainerLeftBorderOffset, thumbnailSectionLeftBorderOffset);

      var directionToShift = shiftDirection(centerOffset,event);

      var rightEdgeSection = isRightEdgeSection(selectedImage);
      var leftEdgeSection = isLeftEdgeSection(selectedImage);

      applyTransform(distanceFromCenter, rightEdgeSection, leftEdgeSection, rightBorderAligned, leftBorderAligned, directionToShift, thumbnailSectionRightBorderOffset, thumbnailContainerRightBorderOffset);

      if(direction === 'next' && !$currentlySelectedImage.next().length || direction === 'prev' && !$currentlySelectedImage.prev().length){
        return;
      }

      $currentlySelectedImage.removeClass('sw-gallery__center-content-thumbnail--selected');
      selectedImage.parent().addClass('sw-gallery__center-content-thumbnail--selected');
      var mainImage = $('[data-sw-gallery-main-image]');
      var mainImageAttribution = $('[data-sw-gallery-image-attribution]');
      var chosenImageSource = selectedImage.attr('src');
      var chosenImageAttributionText = selectedImage.data('swImageAttributionText');
      var chosenImageAttributionLink = selectedImage.data('swImageAttributionLink');
      mainImage.attr('src', chosenImageSource);
      mainImageAttribution.find('span').text(chosenImageAttributionText);
      mainImageAttribution.attr('href', chosenImageAttributionLink);
    };

    $galleryClose.on('click', galleryClosed);
    $galleryOpen.on('click', galleryOpened);
    $prevArrow.on('click', selectPreviousImage);
    $nextArrow.on('click', selectNextImage);
    $galleryImage.on('click', imageSelected);

  });

};
